import { render, staticRenderFns } from "./number_widget.vue?vue&type=template&id=1664c9fd&scoped=true"
import script from "./number_widget.vue?vue&type=script&lang=js"
export * from "./number_widget.vue?vue&type=script&lang=js"
import style0 from "./number_widget.vue?vue&type=style&index=0&id=1664c9fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664c9fd",
  null
  
)

export default component.exports